import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss'
})

export class SuccessComponent {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public dialogRef: MatDialogRef<SuccessComponent>,
  ) {}
  
  close(): void {
    this.dialogRef.close();
  }
  Submit() {
    this.router.navigate(['/home'], { relativeTo: this.activatedRoute }).then(() => {
      this.close(); 
    });
  }
  onCloseDialog(){
    this.router.navigate(['/submissions']);
  }
 
}
